import { useState } from "react";
import Autosave from "./Autosave";
import Button from "ui/buttons/Button";

## Basic Usage

### Saving State

<Autosave autosave="saving" />

### Saved State

<Autosave autosave="saved" />

### Empty State

<Autosave autosave="" />

---

## Interactive Demo

export function AutosaveDemo() {
  const [state, setState] = useState("");
  const simulateSave = () => {
    setState("saving");
    setTimeout(() => {
      setState("saved");
      setTimeout(() => setState(""), 4000);
    }, 1500);
  };
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
      <Button onClick={simulateSave} disabled={state === "saving"}>
        {"Simulate Save"}
      </Button>
      <Autosave autosave={state} />
    </div>
  );
}

<AutosaveDemo />

---

## In a Header Context

<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "1rem", borderBottom: "1px solid #e5e5e5" }}>
  <h3 style={{ margin: 0 }}>Document Editor</h3>
  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <Autosave autosave="saved" />
    <Button btnStyle="tertiary" btnSize="small">Save</Button>
  </div>
</div>

